import {
  makeVuexProp,
  mergeModules,
  makeVuexList,
  vuexPropName,
} from '../../utils/vuexUtils';

const moduleName = 'Bejegyzes';

let {
  module: bejegyzesekStore,
  storeTypes: bejegyzesekStoreTypes,
} = makeVuexList({
  namespace: moduleName,
  listName: 'bejegyzesek',
  key: 'Id',
});

let BejegyzesStoreTypes = {
  bejegyzesek: {
    ...bejegyzesekStoreTypes,
  },
};

let bejegyzes = mergeModules([bejegyzesekStore]);

export { bejegyzes, BejegyzesStoreTypes };
